import { render, staticRenderFns } from "./FileUploader.vue?vue&type=template&id=5b1ecbb6&"
import script from "./FileUploader.vue?vue&type=script&lang=ts&"
export * from "./FileUploader.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/sush/Virtual/cublic-form-api/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5b1ecbb6')) {
      api.createRecord('5b1ecbb6', component.options)
    } else {
      api.reload('5b1ecbb6', component.options)
    }
    module.hot.accept("./FileUploader.vue?vue&type=template&id=5b1ecbb6&", function () {
      api.rerender('5b1ecbb6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resource/component/form/Field/FileUploader.vue"
export default component.exports